import { setLanguage, SupportedLanguage } from "@sadtx/sat-error";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./language-selector.module.css";

interface Language {
  code: string;
  nameKey: string;
}

const languages: Language[] = [
  { code: "ko", nameKey: "language.ko" },
  { code: "en", nameKey: "language.en" },
  { code: "ja", nameKey: "language.ja" },
];

export default function LanguageSelector() {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const selectorRef = useRef<HTMLDivElement>(null);

  const currentLanguage = languages.find((lang) => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    localStorage.setItem("language", languageCode);
    console.log("[LanguageSelector] handleLanguageChange", languageCode);
    console.log("[LanguageSelector] SAT Error 언어 설정이 변경되엇씁니다. in Footer");
    const newLanguageCode = languageCode as SupportedLanguage;
    setLanguage(newLanguageCode);
    setIsOpen(false);
  };

  const toggleSelector = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (selectorRef.current && !selectorRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.languageSelector} ref={selectorRef}>
      <button className={styles.currentLanguage} onClick={toggleSelector}>
        <span className={styles.languageName}>{t(currentLanguage.nameKey)}</span>
        <svg
          className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ""}`}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 6L8 10L12 6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <div className={styles.dropdown}>
          {languages
            .filter((language) => language.code !== i18n.language)
            .map((language) => (
              <button
                key={language.code}
                className={styles.languageOption}
                onClick={() => handleLanguageChange(language.code)}
              >
                <span className={styles.languageName}>{t(language.nameKey)}</span>
              </button>
            ))}
        </div>
      )}
    </div>
  );
}
